import React from 'react'
// import enjoyExperiences from ''
// import tasteExperiences from ''
// import travelExperience from ''

const MainBanner = (props) => {
  return (
    <section className='home-section main-banner'>
      <div className='container-fluid bg-color-ui-4'>
        <div className='container'>
          <div className='row py-3'>
            <div className='col-12'>
              <div className='bx-banner'>
                <h2 className='banner-title spotlight' title='pense em um programa de experiências, desconto e pontos' tabIndex='0'>
                  se é bom <br />
                  negócio, é iupp! <br />
                </h2>
                <p className='sub-text'>
                  quer aumentar suas vendas? <br />
                  a gente te ajuda.
                </p>
                <a href={process.env.REACT_APP_MEU_BAIRRO_ENDPOINT_SIGNUP} title='Ir para quero participar' className='btn btn-default btn-register' tabIndex='0'>eu quero</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MainBanner



// WEBPACK FOOTER //
// ./src/HomePageItauMeuBairro/components/MainBanner.js